import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react"
import Api from "../../utils/Api/Api";
import { trackPaymentEvent, trackCustomEvent, CUSTOM_EVENTS, ANALYTICS_PROVIDERS } from '../../utils/analyticsService';

export const OrderConfirmation = () => {
    const [searchParams] = useSearchParams();
    const order_id = searchParams.get("order_id");
    const status = searchParams.get("status");
    const payment_id = searchParams.get("payment_id");
    const juspay_order_id = searchParams.get("order_id"); // from Juspay

    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(null);
    const [isRedirecting, setIsRedirecting] = useState(false);
    
    useEffect(() => {
        // Track Payment Confirmation Page Viewed
        trackCustomEvent(CUSTOM_EVENTS.PAYMENT_CONFIRMATION_VIEWED, {
            order_id: order_id,
            payment_id: payment_id,
            status: status,
            page_url: window.location.href,
            timestamp: new Date().toISOString(),
            source: 'web'
        },ANALYTICS_PROVIDERS.AMPLITUDE);
        
        const checkPaymentStatus = async () => {
            try {
                // Get payment status from API using Juspay's order ID
                const params = { 
                    order_id: juspay_order_id 
                };
                const { data: confirmationData } = await Api.GetOrderConfirmation(params);
                console.log("Confirmation Data:", confirmationData);
                
                // Track payment status with centralized service
                trackPaymentEvent('processing', {
                    payment_id: confirmationData.payment_id,
                    order_id: confirmationData.order_id,
                    amount: confirmationData.amount,
                    currency: confirmationData.currency || 'INR'
                }, {
                    phone: localStorage.getItem('phoneNo'),
                    email: localStorage.getItem('email'),
                    clientIp: localStorage.getItem('user_ip_address') || ''
                });
                
                // Check if payment is successful based on Juspay status
                if (confirmationData.status === 'CHARGED' || 
                    confirmationData.payment_gateway_response?.resp_code === 'SUCCESS') {
                    
                    // Track successful payment with centralized service
                    trackPaymentEvent('success', {
                        payment_id: confirmationData.payment_id,
                        order_id: confirmationData.order_id,
                        amount: confirmationData.amount,
                        currency: confirmationData.currency || 'INR',
                        payment_method: confirmationData.payment_method,
                        gateway: 'juspay',
                        timestamp: new Date().toISOString(),
                        source: 'web'
                    }, {
                        phone: localStorage.getItem('phoneNo'),
                        email: localStorage.getItem('email'),
                        clientIp: localStorage.getItem('user_ip_address') || ''
                    });
                    
                    // Use the order_id from confirmation data for redirection
                    setIsRedirecting(true);
                    setCountdown(5);
                    
                    // Start countdown timer
                    const countdownInterval = setInterval(() => {
                        setCountdown(prev => {
                            if (prev <= 1) {
                                clearInterval(countdownInterval);
                                navigate(`/order?order_id=${confirmationData.order_id}`);
                                return 0;
                            }
                            return prev - 1;
                        });
                    }, 1000);
                } else {
                    // Track failed payment with centralized service
                    trackPaymentEvent('failed', {
                        payment_id: confirmationData.payment_id,
                        order_id: confirmationData.order_id,
                        amount: confirmationData.amount,
                        currency: confirmationData.currency || 'INR',
                        failure_reason: confirmationData.payment_gateway_response?.resp_message || 'Unknown',
                        gateway: 'juspay',
                        stage: 'payment_gateway_response'
                    }, {
                        phone: localStorage.getItem('phoneNo'),
                        email: '',
                        clientIp: localStorage.getItem('user_ip_address') || ''
                    });
                    
                    // If payment failed, redirect to checkout with failed status
                    console.log("Payment failed, redirecting to checkout");
                    navigate('/checkout?status=failed');
                }
            } catch (err) {
                console.error("Error checking payment status:", err);
                // Use centralized analytics for payment error tracking
                trackCustomEvent(CUSTOM_EVENTS.PAYMENT_INITIATED, {
                    payment_status: 'error',
                    error_type: 'api_error',
                    error_message: err.message
                });
                // If error occurs, redirect to checkout with failed status
                navigate('/checkout?status=failed');
            }
        };

        checkPaymentStatus();
    }, []);
    
    return (
        <>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                color: '#FAFAFA',
                fontFamily: 'Gilroy-Medium',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '18px', marginBottom: '20px' }}>
                    {isRedirecting ? 'Payment Successful!' : 'Processing your order...'}
                </div>
                {isRedirecting && countdown !== null && (
                    <div style={{ 
                        fontSize: '16px', 
                        color: '#4CAF50',
                        fontWeight: 'bold'
                    }}>
                        Redirecting in {countdown} seconds...
                    </div>
                )}
            </div>
        </>
    );
}